import { LineageService } from '@/api/services/LineageService';
import { LineageEntityDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getLineageUpstreamTool: ToolDefinition = {
  name: 'get_lineage_upstream',
  description: 'Get upstream lineage (what asset depends on). Use for upstream dependencies, sources, inputs, or "what does X depend on?". Requires URN; use search_assets first if only name provided. Returns array of upstream assets: name, id, urn, type.',
  input_schema: {
    type: 'object',
    properties: {
      urn: {
        type: 'string',
        description: 'Asset URN. Use search_assets first if only name provided.',
      },
    },
    required: ['urn'],
  },
};

/**
 * Execute the get_lineage_upstream tool
 */
export async function executeGetLineageUpstream(
  params: { urn: string },
): Promise<Array<LineageEntityDto> | { error: string }> {
  try {
    const result = await callWithContext('sifflet-ai-chat', () => LineageService.getLineageUpstreamsByUrn({
      urn: params.urn,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getLineageUpstreamTool;
